import Parse from "../api/ApiConfig";

//
export const fetchParameterById = async (id) => {
	try {
		const Parameters = Parse.Object.extend("Parameters");
		const query = new Parse.Query(Parameters);
		const result = await query.get(id);
		return {
			id: result.id,
			parameter: result.get("parameter"),
			value: result.get("value"),
			period: result.get("period"),
			term: result.get("term"),
		};
	} catch (error) {
		console.error(error);
	}
};
